import { InjectionToken } from '@angular/core';

export const PrizmOverlayContentToken = new InjectionToken('params for overlay');
